export default __webpack_public_path__ + "static/media/six.fff49508.png";